module.exports = "/images/eCommerce-net.png?343a9912f228bf9876f0483866626f65";